export const EDITOR_PANE_FRACTION = 0.45;

// Localstorage Key Name
export const LOCAL_STORAGE_APP_KEY = 'cstree-visualizer-app';

// Default Tree
export const SAMPLE_TREE = `Hamburger
  Meat
    Beef,Brioche,https://en.wikipedia.org/wiki/Beef
    Turkey
  Bread
    White,Spicy|Jalapenos
      Brioche
  Toppings
    Vegetables
      Spicy
      Jalapenos
`;

export const TREE_HORIZONTAL_PADDING = 50; // pixels

export const LAYOUTS = {
  default: 'default', // add more as we come up with more
  traditional: 'traditional', // canonical d3 force layout
  horizontalTree: 'horizontalTree', // static tree layout
  cola: 'cola'
  // Cola Bio Layout
  // traditional: 'traditional', // canonical d3 force layout
}
